import { Building2 } from "lucide-react";

interface Props {
  title?: string;
  description?: string;
}

/**
 * Empty state común cuando el usuario está en una página per-cliente
 * pero no hay ningún cliente activo seleccionado en el ClientPicker.
 */
export function NoClientPicked({
  title = "Elegí un cliente",
  description = "Las páginas están scopeadas por cliente. Elegí uno desde el dropdown de arriba a la izquierda para continuar.",
}: Props) {
  return (
    <div className="px-6 py-12">
      <div className="max-w-md mx-auto text-center">
        <div className="inline-flex h-14 w-14 items-center justify-center rounded-full bg-primary/10 border border-primary/30 mb-4">
          <Building2 className="h-6 w-6 text-primary" />
        </div>
        <h2 className="text-xl font-semibold tracking-tight mb-2">{title}</h2>
        <p className="text-sm text-muted-foreground">{description}</p>
      </div>
    </div>
  );
}
